import { render } from "./AdminNewReservation.vue?vue&type=template&id=61150cb2&scoped=true"
import script from "./AdminNewReservation.vue?vue&type=script&lang=js"
export * from "./AdminNewReservation.vue?vue&type=script&lang=js"

import "./AdminNewReservation.vue?vue&type=style&index=0&id=61150cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61150cb2"]])

export default __exports__